import { useImperativeHandle } from 'react';
import { useFormControls, UseFormControlsParams } from '@mews/framework';
import { WithFormRef } from '../types';

export type UseDialogFormControlsParams<
    InputValues extends object,
    OutputValues extends object = InputValues,
> = UseFormControlsParams<InputValues, OutputValues> & WithFormRef;

export const useDialogFormControls = <InputValues extends object, OutputValues extends object = InputValues>({
    formRef,
    ...props
}: UseDialogFormControlsParams<InputValues, OutputValues>) => {
    const formControls = useFormControls(props);
    const { submit, hasDirtyFields, validate } = formControls;

    useImperativeHandle(
        formRef,
        () => ({
            submit,
            hasDirtyFields,
            // @ts-expect-error: UseFormTrigger<InputValues>' is not assignable to type 'UseFormTrigger<Record<string, unknown>>
            validate,
        }),
        [submit, hasDirtyFields, validate]
    );

    return formControls;
};
